import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

import { EstimateCreatedV1DataSchema } from "./estimate-review-shared";

export const SowChangeElectiveEstimateTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SOW_CHANGE_ELECTIVE_ESTIMATE),
  data: z.discriminatedUnion("version", [EstimateCreatedV1DataSchema]),
});
